<template>
    <div class="nk-content nk-content-fluid" v-cloak>
        <div v-if="accounts==='' && !loading" class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="components-preview wide-md mx-auto">
                    <div class="nk-block nk-block-lg">
                        <div class="card card-bordered card-preview">
                            <div class="card-inner">
                                <div class="preview-block">
                                    <span class="preview-title-lg overline-title">Chart Of Accounts</span>
                                    <div class="row gy-4">
                                        <div class="col-lg-4 col-sm-6 ml-auto mr-auto">
                                            <div class="form-group">
                                                <div class="form-control-wrap">
                                                    <select class="form-select js-select2" data-ui="xl" id="outlined-select">
                                                        <option value="default_option">Select Template</option>
                                                        <option value="Business">{{templatetype}}</option>
                                                    </select>
                                                    <label class="form-label-outlined" for="outlined-select">Select Template</label>
                                                </div>
                                                <br />
                                                <button class="btn btn-primary btn-block btn-round" v-on:click="createChartOfAccount(template)" v-bind:disabled="template==''">Setup Chart of Accounts</button><br />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><!-- .card-preview -->
                    </div><!-- .nk-block -->
                </div><!-- .components-preview -->
            </div>
        </div>



        <div v-else class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="components-preview wide-md mx-auto">
                    <div class="nk-block-head nk-block-head-lg wide-md">
                        <div class="nk-block-head-content">
                            <h3 class="nk-block-title fw-normal text-center">Chart Of Accounts</h3>
                        </div>
                    </div>
                    <div class="nk-block nk-block-lg">
                        <div class="card">
                            <div class="card-inner">
                                <ul class="nav nav-tabs nav-tabs-s2 mt-n2">
                                    <li class="nav-item" v-for="accountType in accounts.accountTypes" v-bind:key="accountType.id">
                                        <a class="nav-link" data-bs-toggle="tab" v-bind:class="{'active show':active == accountType.name}" v-on:click="makeActive(accountType.name)" href="javascript:void(0)">{{accountType.name}}</a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div v-for="accountType in accounts.accountTypes" v-bind:key="accountType.code">
                                        <div class="tab-pane" v-if="active == accountType.name">
                                            <div v-for="costCenter in accountType.costCenters" v-bind:key="costCenter.code" class="nk-block nk-block-lg">
                                                <div class="nk-block-head">
                                                    <div class="nk-block-head-content">
                                                        <h4 class="nk-block-title text-left">{{costCenter.code + ": " + costCenter.name}}</h4>
                                                    </div>
                                                </div>
                                                <div class="card card-bordered card-preview">
                                                    <table class="table table-tranx">
                                                        <thead>
                                                            <tr class="tb-tnx-head">
                                                                <th class="tb-tnx-id" style="width:10%;">#</th>
                                                                <th class="tb-tnx-info" style="width:20%;">
                                                                    Code
                                                                </th>
                                                                <th class="tb-tnx-info" style="width:40%;">
                                                                    Name
                                                                </th>
                                                                <th class="tb-tnx-amount is-alt" style="width:10%;">
                                                                    Status
                                                                </th>
                                                                <th class="tb-tnx-action" style="width:20%;">
                                                                    <span>Action</span>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr class="tb-tnx-item" v-for="(account, index) in costCenter.accounts" v-bind:key="account.code">
                                                                <td class="tb-tnx-id">
                                                                    {{index+1}}
                                                                </td>
                                                                <td class="tb-tnx-info">
                                                                    {{account.code}}
                                                                </td>
                                                                <td class="tb-tnx-amount is-alt">
                                                                    {{account.name}}<br />
                                                                    <span class="small">{{account.description}}</span>
                                                                </td>
                                                                <td class="tb-tnx-amount is-alt">
                                                                    <span v-if="account.isActive" class="badge badge-dot bg-success">Active</span>
                                                                    <span v-else class="badge badge-dot bg-warning">In-Active</span>
                                                                </td>
                                                                <td class="tb-tnx-action">
                                                                    <div class="dropdown">
                                                                        <a class="text-soft dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em class="icon ni ni-more-h"></em></a>
                                                                        <div class="dropdown-menu dropdown-menu-end dropdown-menu-xs">
                                                                            <ul class="link-list-plain">
                                                                                <li><a href="javascript:void(0)">View</a></li>
                                                                                <li><a href="javascript:void(0)" v-on:click="updateModal(account.id, accountType.id, 'Edit')">Edit</a></li>
                                                                                <li><a href="javascript:void(0)" v-on:click="removeAccount(account.id,costCenter.id,accountType.id)">Remove</a></li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <tr class="tb-tnx-item">
                                                                <td class="tb-tnx-info text-center" colspan="5">
                                                                    <a href="javascript:void(0)" class="btn btn-sm btn-primary" v-on:click="addModal(costCenter.id, accountType.id, 'Add')">Add</a>
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div><!-- .card-preview -->
                                            </div><!-- nk-block -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><!-- .card-preview -->
                    </div>
                </div>
            </div>
        </div>

        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>

        <coa-modal :show="showModal"
                   :account="newAccount"
                   :account-type-id="accountTypeId"
                   v-on:close="showModal = false"
                   :type="type"
                   v-if="showModal" />
    </div>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        components: {
            Loading
        },
        data: function () {
            return {
                accounts: '',
                Accounts: '',
                poItem: [],
                loading: false,
                showModal: false,
                active: 'Assets',
                type: "",
                template: 'Business',
                accountTypeId: '',
                accountType: '',
                newAccount: {
                    costCenterId: '',
                    code: '',
                    description: '',
                    id: '',
                    name: '',
                    openingBalance: '',
                    runingBalance: '',
                    isActive: true
                },
                templatetype: '',
                accountslist: []
            }
        },
        methods: {
            makeActive: function (item) {
                this.active = item;
            },
            removeAccount: function (Id, costCenterId, accountTypeId) {
                var root = this;
                // working with IE and Chrome both


                this.$swal({
                    title: "Are you sure?",
                    text: "You will not be able to recover this!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, delete it!"
                }).then(function () {

                     //eslint-disable-line
                    var token = '';
                    if (root.$session.exists()) {
                        token = localStorage.getItem('token');
                    }
                    root.$https.get('/Accounting/RemoveAccount?Id=' + Id, { headers: { "Authorization": `Bearer ${token}` } })
                        .then(function (response) {
                            if (response.data) {
                                var accountDelete = root.accounts.accountTypes.find(function (x) {
                                    return x.id === accountTypeId;
                                }).costCenters.find(function (y) {
                                    return y.id === costCenterId;
                                }).accounts.findIndex(function (z) {
                                    return z.id === Id;
                                });
                                root.accounts.accountTypes.find(function (x) {
                                    return x.id === accountTypeId;
                                }).costCenters.find(function (y) {
                                    return y.id === costCenterId;
                                }).accounts.splice(accountDelete, 1);

                                root.$swal({
                                    title: 'Deleted!',
                                    text: 'Account has been Deleted.',
                                    type: 'success',
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 800,
                                    timerProgressBar: true,
                                });
                            } else {
                                console.log("error: something wrong from db.");
                            }
                        },
                            function (error) {
                                root.$swal({
                                    title: 'Error!',
                                    type: 'error',
                                    text: error,
                                    icon: 'error',
                                    showConfirmButton: false,
                                    timer: 800,
                                    timerProgressBar: true,
                                });
                            });
                });
            },
            createChartOfAccount: function (template) {
                var root = this;
                this.loading = true;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Accounting/TemplateAccountSetup?template=' + template, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(
                        function () {
                            root.$router.go()
                            root.loading = false;
                        });


            },
            updateModal: function (Id, accountTypId, type) {
                var root = this;
                this.showModal = !this.showModal;
                this.type = type;
                this.accountTypeId = accountTypId;

                // working with IE and Chrome both



                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Accounting/GetAccount?Id=' + Id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data.value) {
                            root.newAccount = {
                                id: response.data.account.id,
                                code: response.data.account.code,
                                costCenterId: response.data.account.costCenterId,
                                name: response.data.account.name,
                                isActive: response.data.account.isActive,
                                description: response.data.account.description,
                                openingBalance: response.data.account.openingBalance,
                                runingBalance: response.data.account.runingBalance,
                            };
                        } else {
                            console.log("error: something wrong from db.");
                        }
                    },
                        function () {
                            root.loading = false;
                        });

            },

            addModal: function (costCenterId, accountTypId, type) {
                this.showModal = !this.showModal;
                this.type = type;
                this.accountTypeId = accountTypId;

                this.newAccount = {
                    id: '',
                    code: '',
                    costCenterId: costCenterId,
                    name: '',
                    isActive: true,
                    description: ''
                };

            },
            GetData: function () {
                var token = '';
                var root = this;
                root.loading = true;

                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Accounting/Charts', { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        root.templatetype = "Business"
                        root.$store.dispatch('GetAccountList', response.data);
                        root.accounts = root.$store.state.accounts;
                        root.loading = false;
                    })
            }
        },
        mounted: function () {
            this.GetData();
            this.makeActive('Assets');
        },
    }
</script>